export const snipAddress = (address: string) => `${address.slice(0, 6)}...${address.slice(-4)}`
export const capitalise = (s: string) => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()
